module.exports = __webpack_public_path__ + "img/sysdev_img.f5f204ff.png";